import baseIndexOf from './_baseIndexOf.js';

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

export default charsEndIndex;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash-es/_charsEndIndex.js
// module id = 3409
// module chunks = 0